/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Link } from "react-router-dom";

function ActionCell({ id, handleDeleteAction, parent, disabled }) {
  return (
    <SoftBox display="flex" alignItems="center">
      <SoftBox mx={2}>
        <SoftTypography variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }}>
          <Tooltip
            title={parent == "parent" ? "Yours User" : "Someone's else user"}
            placement="top"
          >
            {parent == "parent" ? (
              <Icon style={{ color: "green", opacity: "0.4" }}>
                supervisor_account_outlined_icon
              </Icon>
            ) : (
              <Icon style={{ color: "red", opacity: "0.2" }}>
                admin_panel_settings_outlined_icon
              </Icon>
            )}
          </Tooltip>
        </SoftTypography>
      </SoftBox>

      <Link to={disabled ? "" : "/management/users/edit/" + id} aria-disabled={disabled}>
        <SoftTypography
          variant="body1"
          color="secondary"
          sx={{
            cursor: disabled ? "not-allowed" : "pointer",
            lineHeight: 0,
            opacity: disabled ? 0.3 : 1,
          }}
        >
          <Tooltip title="Edit User" placement="top">
            <Icon>edit</Icon>
          </Tooltip>
        </SoftTypography>
      </Link>

      <SoftBox mx={2}>
        <SoftTypography
          variant="body1"
          color="secondary"
          sx={{
            cursor: disabled ? "not-allowed" : "pointer",
            lineHeight: 0,
            opacity: disabled ? 0.3 : 1,
          }}
        >
          <Tooltip title="Delete User" placement="top">
            <Icon onClick={disabled ? null : handleDeleteAction} aria-disabled={disabled}>
              delete
            </Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props of the CreateTemplate
ActionCell.propTypes = {
  id: PropTypes.number,
  handleDeleteAction: PropTypes.func,
  parent: PropTypes.string,
  disabled: PropTypes.bool,
};

export default ActionCell;
